(function () {
  var storageKey = 'ag_invitation';
  var targetLocaleStorageKey = 'ag_invitation_target_locale';
  var cartLocaleStorageKey = 'ag_cart_target_locale';
  var previewThemeStorageKey = 'ag_invitation_preview_theme_id';
  var redirectStorageKey = 'ag_invitation_discount_redirected_once';
  var invitationDiscountPath = '/discount/INVITATION1100';

  function getStoredFlag(key) {
    try {
      return window.sessionStorage.getItem(key) === 'true';
    } catch (error) {
      return false;
    }
  }

  function setStoredFlag(key) {
    try {
      window.sessionStorage.setItem(key, 'true');
    } catch (error) {
      // If sessionStorage is unavailable, leave the page behavior unchanged.
    }
  }

  function getStoredValue(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStoredValue(key, value) {
    try {
      if (value) {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      // If sessionStorage is unavailable, leave the page behavior unchanged.
    }
  }

  function clearStoredValue(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // If sessionStorage is unavailable, leave the page behavior unchanged.
    }
  }

  function getPreviewThemeId(params) {
    var previewThemeId = params.get('preview_theme_id') || getStoredValue(previewThemeStorageKey);

    if (!previewThemeId && typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.role === 'unpublished') {
      previewThemeId = Shopify.theme.id;
    }

    return previewThemeId;
  }

  function buildEnglishCartUrl(params) {
    var target = '/en/cart';

    var previewThemeId = getPreviewThemeId(params);

    if (previewThemeId) {
      target += '?preview_theme_id=' + encodeURIComponent(previewThemeId);
    }

    return target;
  }

  function clearInvitationFlags() {
    clearStoredValue(storageKey);
    clearStoredValue(targetLocaleStorageKey);
    clearStoredValue(previewThemeStorageKey);
    clearStoredValue(redirectStorageKey);
  }

  function syncCartLocale(pathname) {
    if (pathname === '/cart' || pathname === '/en/cart') {
      return;
    }

    setStoredValue(cartLocaleStorageKey, isEnglishPath(pathname) ? 'en' : 'ja');
  }

  function isEnglishPath(pathname) {
    return pathname === '/en' || pathname.indexOf('/en/') === 0;
  }

  function setEnglishInvitationContext(params) {
    setStoredFlag(storageKey);
    setStoredValue(targetLocaleStorageKey, 'en');
    setStoredValue(previewThemeStorageKey, params.get('preview_theme_id'));
  }

  document.addEventListener('click', function (event) {
    try {
      var link = event.target.closest('a[href]');

      if (link && link.getAttribute('href').indexOf(invitationDiscountPath) !== -1) {
        setStoredFlag(storageKey);

        if (isEnglishPath(window.location.pathname) || link.getAttribute('href').indexOf('%2Fen%2F') !== -1 || link.getAttribute('href').indexOf('/en/') !== -1) {
          setStoredValue(targetLocaleStorageKey, 'en');
        }
      }
    } catch (error) {
      // Keep normal link navigation intact if click handling fails.
    }
  }, true);

  try {
    var params = new URLSearchParams(window.location.search);
    var pathname = window.location.pathname;

    syncCartLocale(pathname);

    if (params.get('ag_invitation') === '1') {
      if (isEnglishPath(pathname)) {
        setEnglishInvitationContext(params);
      } else {
        setStoredFlag(storageKey);
      }
    }

    if (pathname === '/en/cart') {
      clearInvitationFlags();
      clearStoredValue(cartLocaleStorageKey);
      return;
    }

    if (pathname === '/cart' && getStoredValue(cartLocaleStorageKey) === 'en') {
      clearStoredValue(cartLocaleStorageKey);
      window.location.replace(buildEnglishCartUrl(params));
      return;
    }

    if (pathname === '/cart' && getStoredFlag(storageKey)) {
      clearInvitationFlags();
    }
  } catch (error) {
    // Keep normal navigation intact if URL parsing or redirect logic fails.
  }
})();
